import { useId } from "react";

export interface MemberCheckBadgeProps {
  className?: string;
}

/** The green tick badge overlaid on a selected member avatar. Internal to
 *  `SelectableAvatar`, which owns its placement so the selected state renders
 *  identically across every surface. */
export function MemberCheckBadge({ className }: MemberCheckBadgeProps) {
  const filterId = useId();

  return (
    <svg aria-hidden="true" className={className} fill="none" height="27" viewBox="0 0 27 27" width="27">
      <g filter={`url(#${filterId})`}>
        <circle cx="13.3638" cy="12" fill="var(--color-green-500)" r="12" />
      </g>
      <path
        d="M9.72705 12.4053L12.4048 15.0831L17.7603 9.72754"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.72727"
      />
      <defs>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="26.7273"
          id={filterId}
          width="26.7273"
          x="0.000133157"
          y="0"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="1.36364" />
          <feGaussianBlur stdDeviation="0.681818" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0" />
          <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" mode="normal" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="-1.36364" />
          <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.447014 0 0 0 0 0.570575 0 0 0 0 0.107219 0 0 0 1 0" />
          <feBlend in2="shape" mode="normal" result="effect2_innerShadow" />
        </filter>
      </defs>
    </svg>
  );
}
